import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { modalAside } from "../../../../Store/simulate/actions";

export const useModalAside = (modalAsideState: boolean) => {
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const handleOpen = () => {
    setIsOpen(true);
    document.body.style.overflow = "hidden";
  };

  const handleClose = () => {
    const modalInner = document.querySelector(".modal-aside__inner");
    if (modalInner) {
      modalInner.scrollTop = 0;
    }
    setIsOpen(false);
    dispatch(modalAside(false));
    document.body.style.overflow = "auto";
  };

  useEffect(() => {
    if (modalAsideState) {
      handleOpen();
    } else {
      handleClose();
    }
  }, [modalAsideState]);

  return { isOpen, handleClose };
};
